module.exports = __webpack_public_path__ + "static/media/moduleSet_i6o1.325d581a.jpg";